<p-toolbar>
  <div class="p-toolbar-group-left">
    <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
    <!-- Display only on bigger than md screens-->
    <span style="padding-top:2px;">
      <button (click)="loadReportData()"
              pButton type="button" 
              class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
              icon="pi pi-fw pi-refresh"></button>
      <span class="p-d-none p-d-md-inline">
        <button pButton pRipple 
                label="Excel Export" 
                class="p-button p-button-text" 
                [class.disabled]="exporting"
                icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"
                (click)="exportToExcel()"></button>

      </span>

      <!-- Display only on smaller than md screens-->
      <span class="p-d-md-none">
        <button pButton pRipple 
                class="p-button-rounded p-button-success" 
                icon="pi pi-refresh" 
                type="button" 
                (click)="exportToExcel()"></button>

      </span>
    </span>
  </div>
</p-toolbar>

<div class="m-1" style="height:calc(100% - 36px)">
  <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
               size="default"
               color="#2f9cf2"
               type="line-scale-pulse-out"
               [name]="spinnerName"
               [fullScreen]="false">
    <p style="color:white" >Generating po/invoice discrepancy report...</p>
  </ngx-spinner>

  <p-table  [value]="reportItems" id="po-invoice-discrepancy-table"
            [scrollable]="true" scrollHeight="flex"
            selectionMode="single"
            styleClass="p-datatable-gridlines">
    <ng-template pTemplate="header">
      <tr>
        <th class="p-text-bold text-right" style="width:40px; background-color: var(--surface-300);">#</th>
        <th class="p-text-bold" style="width:90px">PO No</th>
        <th class="p-text-bold text-right" style="width:90px">PO Amount</th>
        <th class="p-text-bold text-right" style="width:100px">Total Invoice Value</th>
        <th class="p-text-bold" style="width:100px">Project No</th>
        <th class="p-text-bold" style="min-width:160px">Project Description</th>
        <th class="p-text-bold" style="width:100px">Installation Progress</th>
        <th class="p-text-bold text-right" style="width:120px">Total Project Invoice Value</th>
        <th class="p-text-bold" style="width:100px">Invoice No</th>
        <th class="p-text-bold" style="width:100px">Invoice Date</th>
        <th class="p-text-bold" style="width:130px">Income Month</th>
        <th class="p-text-bold text-right" style="width:100px">Invoice Value</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-reportItem let-rowIndex="rowIndex">
      <tr>
        <td class="text-right" style="width:40px; background-color: var(--surface-300);">{{rowIndex + 1}}</td>
        <td class="text-danger" style="width:90px">{{reportItem.poNo}}</td>
        <td class="text-danger text-right" style="width:90px">{{reportItem.poAmount}}</td>
        <td class="text-danger text-right" style="width:100px">{{reportItem.totalPoInvoiceValue}}</td>
        <td [class.bg-light-yellow]="!!reportItem.projectNo" style="width:100px">{{reportItem.projectNo}}</td>
        <td [class.bg-light-yellow]="!!reportItem.projectNo" style="min-width:160px">{{reportItem.projectDescription}}</td>
        <td [class.bg-light-yellow]="!!reportItem.projectNo" style="width:100px">{{reportItem.installationProgress}}</td>
        <td [class.bg-light-yellow]="!!reportItem.projectNo" class="text-right" style="width:120px">{{reportItem.totalProjectInvoiceValue}}</td>
        <td class="bg-darker-yellow" style="width:100px">{{reportItem.invoiceNo}}</td>
        <td class="bg-darker-yellow" style="width:100px">{{reportItem.invoiceDate}}</td>
        <td class="bg-darker-yellow" style="width:130px">{{reportItem.incomeMonth}}</td>
        <td class="text-right bg-darker-yellow" style="width:100px">{{reportItem.invoiceValue}}</td>
      </tr>
    </ng-template>
  </p-table>
  
</div>

